import { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FilterGroup } from '@models/SearchFilter';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';

import FilterDialog from './FilterDialog';
import ToolbarButton from './ToolbarButton';

type SearchFilterButtonProps = {
  updateFilter: (newFilter: FilterGroup) => void;
};

const SearchFilterButton: FC<SearchFilterButtonProps> = ({ updateFilter }) => {
  const { t } = useTranslation();
  const { filterCount: searchFilterCount, isReadonly } = useSearchAndFilter();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Fragment>
      <ToolbarButton
        disabled={isReadonly}
        onClick={() => setIsOpen(true)}
        rightIcon='filterAlt'
        title={t('searchAndFilter.filters', { count: searchFilterCount })}
      />

      <FilterDialog isOpen={isOpen} onClose={() => setIsOpen(false)} updateFilter={updateFilter} />
    </Fragment>
  );
};

export default SearchFilterButton;
